import React, { useEffect, useState, useMemo } from "react";
import debounce from "lodash.debounce";
import Header from "../component/layout/Header";
import Footer from "../component/layout/Footer";
import { FaSearch, FaSpinner } from "react-icons/fa";
import LocationCard from "../component/Location/LocationCard.jsx";
import locatio1stimage from "../assets/location1st.png";
import { setRestaurantId } from "../redux/restaurantSlice.js";
import { saveToLocalStorage } from "../redux/helpers/localStorage.js";
import api from "../utils/api.js";
import { useDispatch } from "react-redux";
import { TiTick } from "react-icons/ti";

import Cookies from 'js-cookie'
function LocationsPage() {
  const [locationData, setLocationData] = useState([]); // Full restaurant data
  console.log("🚀 ~ LocationsPage ~ locationData:", locationData)
  const [filteredData, setFilteredData] = useState([]); // Filtered data for display
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");
  const RestaurantSavedId =  JSON.parse(localStorage.getItem('selectedRestaurantId'))
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Fetch all restaurant data once
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        // Simulating API call to fetch all data
        const response = await api.get("/restaurant");
        const results = response.data.results || [];
        setLocationData(results); // Save full data
        setFilteredData(results); // Initially, all data is displayed
      } catch (error) {
        console.error("Error fetching restaurant data:", error);
      }
      setLoading(false);
    };
    fetchData();
  }, []);

  // Handle input change and search
  const handleInputChange = (e) => {
    const query = e.target.value.toLowerCase(); // Convert query to lowercase
    setSearchQuery(query);

    // Filter the data based on the title
    const filtered = locationData.filter((location) =>
      location.title.toLowerCase().includes(query)
    );
    setFilteredData(filtered);
  };
const handlestoreSelect = (restaurant)=>{
    saveToLocalStorage("selectedRestaurantId", restaurant._id);
    dispatch(setRestaurantId(restaurant._id));
    Cookies.set("selectedRestaurantName", restaurant?.title);
    Cookies.set("selectedSlug", restaurant?.slug);
    window.location.reload();
};
  return (
    <div className="flex overflow-hidden mt-0 flex-col">
      <Header activeLink={"locations"} />
      <div className="px-16 py-6 w-full text-6xl font-bold tracking-wide heading text-center text-white whitespace-nowrap bg-[#AF313D]  max-md:px-5 max-md:max-w-full max-md:text-4xl">
        Stores
      </div>
      <form className="flex flex-wrap gap-8 self-center mt-8 max-w-full text-xl font-semibold w-[771px] px-2">
        <div className="flex flex-wrap flex-auto gap-10 px-8 body border-2 border-solid border-neutral-500 rounded-[40px] text-neutral-500 max-md:px-5 max-md:max-w-full">
          <label htmlFor="locationSearch" className="sr-only">
            Search Location
          </label>
          <input
            id="locationSearch"
            type="text"
            value={searchQuery}
            onChange={handleInputChange} // Call filter function on input change
            placeholder="Search Location by title"
            className="flex-grow bg-transparent border-none outline-none h-[45px] max-sm:placeholder:text-[12px] max-w-full max-sm:h-[35px] max-sm:w-[35px]"
          />
          <FaSearch className="my-auto text-[#AD343E]" size={20} />
        </div>
      </form>
    <div className=" flex justify-center items-center text-white font-semibold capitalize mb-4 mt-6 bg-[#AF313D]  py-2 font-baloo">
    <h1 className=" ">you can choose any store listed below and proceed ordering from its menu</h1>
    </div>
      <div className="self-center mt-8 w-full max-w-[95%] max-md:max-w-full">
        {loading ? (
          <div className="flex justify-center items-center min-h-screen">
            <FaSpinner className="animate-spin text-4xl text-[#C97C2A]" />
          </div>
        ) : filteredData.length > 0 ? (
          <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 px-2 gap-5">
         {filteredData.map((location, index) => (
  <div
    onClick={() => handlestoreSelect(location)}
    key={index}
    className={`flex flex-col cursor-pointer w-full rounded-3xl relative  ${location._id === RestaurantSavedId ? `border-rose-700 border-2` : 'border-white'}`}
  >
    {location._id === RestaurantSavedId && (
      <TiTick className="absolute top-0 right-0 text-green-600 text-7xl" />
    )}
    <LocationCard
      imageSrc={location.coverImage ? location.coverImage[0] : locatio1stimage}
      name={location.title}
      hours={`${
        location.weeks && location.weeks[0]
          ? `${location.weeks[0].openTime} to ${location.weeks[0].closeTime}`
          : "N/A"
      }`}
      address={location.address}
    />
  </div>
))}

          </div>
        ) : (
          <div className="flex justify-center items-center min-h-screen text-xl text-gray-500">
            No locations found.
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
}

export default LocationsPage;
